/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ActivityPageThreadedFeedRequest} from '@cash-web/protos/squareup/cash/activity/api/v1/service.pb'
import {ActivityPageThreadedFeedResponse} from '@cash-web/protos/squareup/cash/activity/api/v1/service.pb'


export const activityPageThreadedFeed = (request:ActivityPageThreadedFeedRequest, options?: CashRequestOptions) => post<ActivityPageThreadedFeedRequest, ActivityPageThreadedFeedResponse>("/2.0/cash/activity-page-threaded-feed", request, {...options, rejectOnError: true })